export enum TransactionType {
  Card = 'CARD',
  CashDeposit = 'CASH_DEPOSIT',
  CashWithdrawal = 'CASH_WITHDRAWAL',
  Check = 'CHECK',
  DirectDebit = 'DIRECT_DEBIT',
  InstantTransfer = 'INSTANT_TRANSFER',
  InternalCounterEntry = 'INTERNAL_COUNTER_ENTRY',
  InternationalTransfer = 'INTERNATIONAL_TRANSFER',
  IntraCompanyFundsTransfer = 'INTRA_COMPANY_FUNDS_TRANSFER',
  PeerToPeer = 'PEER_TO_PEER',
  SwiftTransfer = 'SWIFT_TRANSFER',
  Transfer = 'TRANSFER',
  Unknown = 'UNKNOWN',
  VirtualCard = 'VIRTUAL_CARD',
  WalletTransfer = 'WALLET_TRANSFER',
}
